export default "__VITE_ASSET__CqaTeGzJ__"